import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	row: {
		border: `1px solid ${colors.purple[200]}`,
		backgroundColor: colors.purple[50],
		borderRadius: "9px",
		padding: "16px 18px",
		gap: "16px"
	},
	iconBox: {
		width: "30px",
		height: "30px",
		borderRadius: "8px",
		backgroundColor: colors.purple[100],
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexShrink: 0
	},
	icon: {
		color: colors.purple[700],
		fontSize: "18px"
	},
	title: {
		color: colors.gray[900]
	},
	badge: {
		textTransform: "uppercase",
		fontSize: "9.5px",
		fontWeight: 500,
		letterSpacing: "0.04em",
		color: colors.purple[700],
		backgroundColor: colors.purple[100],
		borderRadius: "4px",
		padding: "2px 7px"
	},
	description: {
		fontSize: "11.5px",
		lineHeight: 1.45,
		color: colors.gray[500]
	}
}))

export default useStyles
